import React from 'react';
import PropTypes from 'prop-types';

import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Tooltip from '@zg-rentals/multibrand-ui/lib/Tooltip';
import HelpCircleFill from '@zg-rentals/multibrand-ui/lib/icons/HelpCircleFill';
import SectionComment from '../SectionComment';
import { getApplicantFirstName } from '../../../../../../../utils/applicantDetailsUtil';

const REPORT_TEXT = 'No file found';

function UserNotFoundTooltip() {
  return (
    <Tooltip trigger="click" position="bottom">
      <Tooltip.Target>
        <HelpCircleFill size="sm" />
      </Tooltip.Target>
      <Text>No report is currently available. The applicant’s identity could not be verified.</Text>
    </Tooltip>
  );
}

export default function UserNotFoundSection({ applicant, sectionComment, title }) {
  const applicantName = getApplicantFirstName(applicant);

  return (
    <div className="ApplicantSection__Row">
      <Text type="h3">{title}</Text>
      <Text>
        {REPORT_TEXT}&nbsp;
        <UserNotFoundTooltip />
      </Text>
      <SectionComment applicantName={applicantName} sectionComment={sectionComment} />
    </div>
  );
}

UserNotFoundSection.propTypes = {
  applicant: PropTypes.shape({
    firstName: PropTypes.string,
    contactInfo: PropTypes.shape({
      coapplicantFirstName: PropTypes.string,
    }),
  }).isRequired,
  sectionComment: SectionComment.propTypes.sectionComment,
  title: PropTypes.string.isRequired,
};
